// src/utils/qualityUtils.js

/**
 * Extracts the resolution number from a quality string.
 * @param {string} quality - The quality string (e.g., "720p.WEBRip").
 * @returns {number} - The resolution number (e.g., 720). Returns 0 if not found.
 */
export const getResolution = (quality) => {
    const match = quality.match(/(\d{3,4})p/i);
    return match ? parseInt(match[1], 10) : 0;
  };
  